import * as api from '.';
import { wishlistAPI } from '../config';
import type { SortValue } from '../sortSelector/SortSelector';
import type { UserData } from './product';

export interface List {
    code: string;
    name: string;
    numberOfEntries: number;
    userDefined: boolean;
}

export interface ProductInList {
    readonly inList: boolean;
    readonly name: string;
    readonly code: string;
}

function getOrStoreSortOrder(sort?: string): string | undefined {
    if (sort) {
        localStorage.setItem('wishlistSort', sort);
        return sort;
    } else {
        return localStorage.getItem('wishlistSort') ?? undefined;
    }
}

export async function getListOfWishlists(sort?: string) {
    sort = getOrStoreSortOrder(sort);

    return await api.get<{
        defaultLists: List[];
        customLists: List[];
        sorts: SortValue[];
    }>(wishlistAPI.getListOfWishlistsURL(), sort ? { sort } : undefined);
}

export async function getProductInWishlists(productCode: string, sort?: string) {
    sort = getOrStoreSortOrder(sort);

    return await api.get<{
        lists: ProductInList[];
        favourite: ProductInList;
        sorts: SortValue[];
    }>(wishlistAPI.getProductInWishlistsURL(productCode), sort ? { sort } : undefined);
}
export async function addToWishlist(listId: string, productCode: string) {
    return await api.post<UserData>(wishlistAPI.getWishlistEntriesURL(listId), { productCode });
}

export async function removeFromWishlist(listId: string, productCode: string) {
    return await api.delete<UserData>(wishlistAPI.getWishlistProductEntryURL(listId, productCode));
}
